import {
  PROJECT_LIST_GET,
  PRODUCT_SELECT_LIST_GET,
  PRODUCT_LIST_GET,
  PRODUCT_INDUSTRY_LIST_GET,
  PROJECT_CONSTANT_LIST_GET,
  PROJECT_LOG_GET,
  PRODUCT_CHANGE_LIST_PAGE_GET,
  PUBLIC_DETAIL_GET,
  PUBLIC_HAS_SIMILARITY,
  SYSTEM_PROJECT_CONFIG_GET,
  COUNTRY_LIST_GET,
} from "src/fetch/url";
import { curl } from 'zh-common-modules';
import { get } from 'src/fetch/fetch';
import { actionTypes } from "./constants";

export const setProjectList = data => ({
  type: actionTypes.SET_PROJECT_LIST,
  data
});
export const setProductList = data => ({
  type: actionTypes.SET_PRODUCT_LIST,
  data
});
export const setProductSelectList = data => ({
  type: actionTypes.SET_PRODUCT_SELECT_LIST,
  data
});
export const setIndustryTypeList = data => ({
  type: actionTypes.SET_INDUSTRY_TYPE_LIST,
  data
});
export const setMessage = data => ({
  type: actionTypes.SET_MESSAGE,
  data
});

export const setConstantList = data => ({
  type: actionTypes.SET_CONSTANT_LIST,
  data
});

export const setProjectLog = data => ({
  type: actionTypes.SET_PROJECT_LOG,
  data
});

export const setProjectChangePageList = data => ({
  type: actionTypes.SET_PROJECT_CHANGE_PAGE_LIST,
  data
});

export const setCountryList = data => ({
  type: actionTypes.SET_COUNTRY_LIST,
  data
});

export const getProjectList = (params, cb) => {
  return (dispatch) => {
    get(PROJECT_LIST_GET, params)
      .then(res => {
        if (res && res.success) {
          ;
          const data = {
            total: res.content.total,
            list: res.content.rows,
            stats: res.content.stats
          };
          cb?.(res.content);
          dispatch(setProjectList(data));
        }
      });
  };
};
export const getSelectProductList = (params, cb) => {
  return (dispatch) => {
    get(PRODUCT_SELECT_LIST_GET, params)
      .then(res => {
        if (res && res.success) {
          const data = res.content;
          dispatch(setProductSelectList(data));
          cb && cb(data);
        }
      });
  };
};
export const getProductList = (params, cb) => {
  return (dispatch) => {
    get(PRODUCT_LIST_GET, params)
      .then(res => {
        if (res && res.success) {
          const data = {
            total: res.content.total,
            list: res.content.rows
          };
          cb?.(res.content);
          dispatch(setProductList(data));
        }
      });
  };
};

export const getIndustryTypeList = (params, cb) => {
  return (dispatch) => {
    get(PRODUCT_INDUSTRY_LIST_GET, params)
      .then(res => {
        if (res && res.success) {
          const data = {
            total: res.content.count,
            list: res.content.rows || [],
          };
          cb?.(data);
          dispatch(setIndustryTypeList(data));
        }
      });
  };
};

export const getConstantList = (params, cb) => {
  return (dispatch) => {
    curl
      .get(PROJECT_CONSTANT_LIST_GET, params)
      .then(res => {
        dispatch(setConstantList(res));
        cb && cb(res);
      });
  };
};

export const getProjectLog = (params, cb) => {
  return (dispatch) => {
    curl
      .get(PROJECT_LOG_GET, params)
      .then(res => {
        dispatch(setProjectLog(res));
        cb && cb(res);
      });
  };
};

export const getProjectChangePageList = (params, cb) => {
  return (dispatch) => {
    curl
      .get(PRODUCT_CHANGE_LIST_PAGE_GET, params)
      .then(res => {
        dispatch(setProjectChangePageList(res));
        cb && cb(res);
      });
  };
};

export const getProjectDetail = (params, cb) => {
  return (dispatch) => {
    curl
      .get(PUBLIC_DETAIL_GET, params)
      .then(res => {
        cb && cb(res);
      });
  };
};

/**
 * 获取相似商机
 * @param {*} params 参数
 * @param {*} cb 回调
 * @returns 
 */
export const getProjectSimilarity = (params, cb) => {
  return (dispatch) => {
    curl
      .get(PUBLIC_HAS_SIMILARITY, params)
      .then(res => {
        cb && cb(res);
      });
  };
};

/**
 * 获取商机配置
 * @param {*} params 参数
 * @param {*} cb 回调
 * @returns 
 */
export const getProjectConfig = (params, cb) => {
  return (dispatch) => {
    curl
      .get(SYSTEM_PROJECT_CONFIG_GET, params)
      .then(res => {
        cb && cb(res);
      });
  };
};


export const getAllCountryList = (params, cb) => {
  return (dispatch) => {
    curl
      .get(COUNTRY_LIST_GET, params)
      .then((res) => {
        dispatch(setCountryList(res));
        cb && cb(res);
      });
  };
};
